// extracted by mini-css-extract-plugin
export default {"convert-button":"UpgradeCard_convert-button__7BumD","button-panel":"UpgradeCard_button-panel__ta26E","dashboard-button":"UpgradeCard_dashboard-button__wCEpn"};